var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class Yinker {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'PING',
                next: /FHDM\d\d/i,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GetMCUFWVer`, /MCUVer\s*([\d\.]+)/, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                // Returned value is the result for all outputs
                const match = yield this.socket.send(`GetSW`, /SWS\s*([\d\s]+)/i, tags);
                const inputs = match[1].split(' ');
                const result = inputs[parseInt(key, 10) - 1];
                return result;
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                // Returned value is the result for all outputs
                const match = yield this.socket.send(`SW ${value} ${key}`, /SWS\s*([\d\s]+)/i, tags);
                const inputs = match[1].split(' ');
                const result = inputs[parseInt(key, 10) - 1];
                return result;
            }),
            asyncHandlers: [
                {
                    regExp: /SWS\s*([\d\s]+)/i,
                    callback: (match) => {
                        const inputs = match[1].split(' ');
                        inputs.forEach((item, i) => {
                            this.state.videoMatrixRoutes.update((i + 1).toString(), item);
                        });
                    },
                },
            ],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
Yinker.driverType = 'socketDriver';
Yinker.key = '-OJsCCHRd3L19A9Uv06m';
Yinker.socketOptions = [
    {
        commandExtractor: {
            terminators: ['\r', '\n'],
        },
        port: 4999,
        sendTerminator: '\r\n',
    },
];
